import { v4 as uuidv4 } from 'uuid'
import { getParam } from '../helpers/parameters'

export const phoneAuthService = {
  generatePin: async (phoneNumber) => {
    try {
      let session = sessionStorage.getItem('sessionId')

      if (!session) {
        session = uuidv4()
        sessionStorage.setItem('sessionId', session)
      }

      const apiBase = await getParam('phoneAuthApiBase')
      const response = await fetch(
        `${apiBase}/services/phone-verification/generate-pin`,
        {
          method: 'POST',
          body: JSON.stringify({
            min: phoneNumber,
            session,
          }),
        },
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      return data
    } catch (error) {
      console.error('Error generating PIN:', error)
      throw error
    }
  },

  validatePin: async (phoneNumber, pin) => {
    try {
      const session = sessionStorage.getItem('sessionId')

      const apiBase = await getParam('phoneAuthApiBase')
      const response = await fetch(
        `${apiBase}/services/phone-verification/validate-pin`,
        {
          method: 'POST',
          body: JSON.stringify({
            min: phoneNumber,
            pin,
            session,
          }),
        },
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const {
        response: { data },
      } = await response.json()

      if (data.phoneVerificationToken) {
        localStorage.setItem('authToken', data.phoneVerificationToken)
      }

      return data
    } catch (error) {
      console.error('Error validating PIN:', error)
      throw error
    }
  },

  clearAuth: () => {
    localStorage.removeItem('authToken')
    sessionStorage.removeItem('sessionId')
  },

  isAuthenticated: () => !!localStorage.getItem('authToken'),
}
